import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Modal, Button, Form } from '_zari/core'

import * as TransaccionCrud from 'services/transaccion.service'

import * as FormGroups from './formGroups'
import { ValidationSchema } from './validation'

const NuevoModal = ({ handleClose, show, reloadTable }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(
    () => ({
      codigo: '',
      descripcion: ''
    }),
    []
  )

  const submitHandler = async data => {
    await TransaccionCrud.crearTransaccion(data)
      .then(() => {
        __zariContext.snack('success', 'El registro se ha creado.')
        reloadTable()
        handleClose()
      })
  }

  return (
    <Modal show={show} onHide={handleClose} size='sm'>
      <Modal.Header>
        <Modal.Title>NUEVA TRANSACCION</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
        {({ errors, handleSubmit, isSubmitting, touched, values }) => (
          <Form>
            <Modal.Body>
              <FormGroups.CodigoFormGroup iError={errors.codigo} fIsSubmitting={isSubmitting} iTouched={touched.codigo} />
              <FormGroups.DescripcionFormGroup iError={errors.descripcion} iTouched={touched.descripcion} fIsSubmitting={isSubmitting} />
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>Crear</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default NuevoModal
